// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__yXAcX","wrapper":"PriceList_wrapper__shhmV","pricing":"PriceList_pricing__GEj+Z","footerStyle":"PriceList_footerStyle__poONu"};